export const resetCategories = (item, categories) => {
  if (JSON.stringify(item.categories) == "[0]") {
  	const CategoryIds = categories.map((item, index) => { return item.id })
  	item.categories = CategoryIds
  }
  return item
}
